import React, { PropsWithChildren, ReactElement } from 'react';
import { FilterGeneratorProps } from '..';
import FilterRange from '../../filter-popup/filter-range';
import FilterDateOption from '../../filter-popup/filter-date-option';
import { useTranslateWithStringArgs } from 'src/ui/hooks/use-translate';

export const FilterGeneratorDate = <Data,>(
  props: PropsWithChildren<FilterGeneratorProps<Data>>,
): ReactElement | null => {
  const { cellData } = props;

  const translate = useTranslateWithStringArgs();

  const filterLabels = {
    filterName: cellData.filterName || '',
    filterAfterValue: `${cellData.filterName}After`,
    filterBeforeValue: `${cellData.filterName}Before`,
  };
  const renderDateRangeFilter = () => {
    return (
      <FilterRange
        label={cellData.title}
        inputNames={[filterLabels.filterAfterValue, filterLabels.filterBeforeValue]}
        filterName={filterLabels.filterName}
      >
        <FilterDateOption
          input={filterLabels.filterAfterValue}
          pairedInput={filterLabels.filterBeforeValue}
          label={null}
          defaultField={filterLabels.filterAfterValue}
          name={filterLabels.filterName}
          placeholder={translate('common.from')}
        />
        <FilterDateOption
          input={filterLabels.filterBeforeValue}
          pairedInput={filterLabels.filterAfterValue}
          label={null}
          defaultField={filterLabels.filterBeforeValue}
          name={filterLabels.filterName}
          placeholder={translate('common.to')}
        />
      </FilterRange>
    );
  };

  return renderDateRangeFilter();
};
